/** Turn a 24-hour clock into 12-hour with AM/PM. A trailing +1 day marker is kept. */
export function formatLocalHm(raw: string): string {
  if (!raw) return '';
  const dayOffset = raw.match(/(\+\d+)\s*$/)?.[1] ?? '';
  const withoutOffset = raw.replace(/\+\d+\s*$/, '');
  const t = withoutOffset.includes('T') ? (withoutOffset.split('T')[1] ?? withoutOffset) : withoutOffset;
  const [hs, ms = '00'] = t.split(':');
  const h24 = parseInt(hs ?? '', 10);
  if (Number.isNaN(h24) || h24 < 0 || h24 > 23) return raw;
  const mins = (ms ?? '00').replace(/\D.*$/, '').slice(0, 2);
  if (!/^\d{2}$/.test(mins)) return raw;
  const suffix = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 || 12;
  return `${h12}:${mins} ${suffix}${dayOffset ? ` ${dayOffset}` : ''}`;
}

/** Replace 24-hour clocks in a sentence. Leaves "7:30 PM" and durations like "6h 45m" alone. */
const CLOCK_IN_TEXT = /(?<!\d)([01]?\d|2[0-3]):([0-5]\d)(?!\d)(?!\s*(?:AM|PM)\b)/gi;

export function formatClockInText(text: string): string {
  return text.replace(CLOCK_IN_TEXT, (_match, hour: string, minute: string) => formatLocalHm(`${hour}:${minute}`));
}
